module.exports = __webpack_public_path__ + "img/br-klassik.05a3d2c9.png";